<style src='./style.scss'>

</style>

<article class="mbsc-row">
  <header class="mbsc-col-12">
    <h1>Mi Cuenta</h1>
  </header>
</article>

<div class="md-master-detail-demo">
    <div class="mbsc-grid mbsc-no-padding">
        <div class="mbsc-row">
            <div class="mbsc-col-12 mbsc-col-md-2 mbsc-col-sm-3">
              <ul id="master-detail-list" class="mbsc-cloak">
                <li data-item="a" data-selected="true">Membresías</li>
                <li data-item="b">Preferencias</li>
              </ul>
            </div>
            <div class="mbsc-col-12 mbsc-col-md-10 mbsc-col-sm-9 md-col-border">
                <ul id="master-detail-tab" class="mbsc-cloak">
                    <li data-tab="profile" data-selected="true">Mi Cuenta</li>
                </ul>
                <div id="master-item-a" class="md-master-item md-master-item-sel mbsc-form-grid">
                    <div class="master-tab-profile md-master-tab md-master-tab-sel">
                      <CurrentMembership></CurrentMembership>
                      <Pricing
                        mode="short"
                      ></Pricing>
                    </div>
                    <div class="master-tab-conv md-master-tab"></div>
                    <div class="master-tab-tasks md-master-tab"></div>
                </div>
                <div id="master-item-b" class="md-master-item mbsc-form-grid">
                    <div class="master-tab-profile md-master-tab md-master-tab-sel">
                      <AccountDetails></AccountDetails>
                    </div>
                    <div class="master-tab-conv md-master-tab"></div>
                    <div class="master-tab-tasks md-master-tab"></div>
                </div>
                <div id="master-item-c" class="md-master-item mbsc-form-grid">
                    <div class="master-tab-profile md-master-tab md-master-tab-sel"></div>
                    <div class="master-tab-conv md-master-tab"></div>
                    <div class="master-tab-tasks md-master-tab"></div>
                </div>
                <div id="master-item-k" class="md-master-item mbsc-form-grid">
                    <div class="master-tab-profile md-master-tab md-master-tab-sel"></div>
                    <div class="master-tab-conv md-master-tab"></div>
                    <div class="master-tab-tasks md-master-tab"></div>
                </div>
                <div id="master-item-l" class="md-master-item mbsc-form-grid">
                    <div class="master-tab-profile md-master-tab md-master-tab-sel"></div>
                    <div class="master-tab-conv md-master-tab"></div>
                    <div class="master-tab-tasks md-master-tab"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<script>
import { onMount, afterUpdate } from 'svelte';

import AccountDetails from '@Components/AccountDetails/index.svelte';
import CurrentMembership from '@Components/CurrentMembership/index.svelte';
import Pricing from '@Components/Pricing/index.svelte';

const DEBUG = document.location.protocol === 'http:' ? true : false;

afterUpdate(() => {});

onMount(async () =>{
  mobiscroll.settings = {
      theme: 'd-ns',
      themeVariant: 'light'
  };

  mobiscroll.form('.md-master-detail-demo');

  mobiscroll.listview('#master-detail-list', {
      select: 'single',
      onItemTap: function (event, inst) {
        document.querySelector('.md-master-item-sel').classList.remove('md-master-item-sel');
        document.querySelector('#master-item-' + event.target.getAttribute('data-item')).classList.add('md-master-item-sel');
        // resize textarea
        if (document.querySelector('.md-master-item-sel textarea')) {
          document.querySelector('.md-master-item-sel textarea').dispatchEvent(new Event('mbsc-enhance', { bubbles: true }));
        }
      }
  });

  mobiscroll.nav('#master-detail-tab', {
      type: 'tab',
      display: 'inline',
      onInit: function (event, inst) {},
      onItemTap: function (event, inst) {
        var oldTabs = document.querySelectorAll('.md-master-tab-sel');
        var selTabs = document.querySelectorAll('.master-tab-' + event.target.getAttribute('data-tab'));

        for (var i = 0; i < oldTabs.length; ++i) {
          oldTabs[i].classList.remove('md-master-tab-sel');
          selTabs[i].classList.add('md-master-tab-sel');
        }
        // resize textarea
        if (document.querySelector('.md-master-tab-sel textarea')) {
          document.querySelector('.md-master-tab-sel textarea').dispatchEvent(new Event('mbsc-enhance', { bubbles: true }));
        }
      }
  });
});
</script>